export function getBankFullInfo(bank: any) {
  return `${bank?.name} • ${bank?.number} • ${bank?.account}`;
}
